import React from "react";
import { ExcelColumnProps } from "react-xlsx-wrapper";

export default class ExcelColumn extends React.Component<ExcelColumnProps> {
  render() {
    return null;
  }
}
 